import { SubCategoryBarOptions } from 'shared/types/product/Category';

export const getDynamicMegaMenuStyle = (
  cols: number,
  subcategoryOptions: SubCategoryBarOptions[] = [],
): React.CSSProperties => {
  const validSubSubCount = subcategoryOptions.reduce(
    (count, sub) =>
      count +
      (sub?.subSubCategoryOptions?.filter(
        (item) => typeof item?.subSubCategoryName === 'string' && item.subSubCategoryName.trim().length > 0,
      ).length ?? 0),
    0,
  );

  if (validSubSubCount === 0) {
    return { display: 'flex', flexDirection: 'column', gap: '24px' };
  }

  if (validSubSubCount === 1) {
    return { display: 'grid', gridTemplateColumns: '1fr', columnGap: '40px' };
  }

  // Use standard CSS for dynamic values
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(${Math.min(cols, 4)}, max-content)`,
    columnGap: '50px',
  };
};

export const getStackedSubCategories = (subcategoryOptions: SubCategoryBarOptions[] = []): SubCategoryBarOptions[] => {
  if (!Array.isArray(subcategoryOptions) || subcategoryOptions.length === 0) {
    return [];
  }

  return subcategoryOptions.filter(
    (sub) =>
      !sub?.subSubCategoryOptions?.some(
        (item) => typeof item?.subSubCategoryName === 'string' && item.subSubCategoryName.trim().length > 0,
      ),
  );
};

export const getFilteredSubCategoriesWithValidSubSubs = (
  subcategoryOptions: SubCategoryBarOptions[] = [],
): SubCategoryBarOptions[] => {
  if (!Array.isArray(subcategoryOptions) || subcategoryOptions.length === 0) {
    return [];
  }

  return subcategoryOptions.filter((sub) =>
    sub?.subSubCategoryOptions?.some(
      (item) => typeof item?.subSubCategoryName === 'string' && item.subSubCategoryName.trim().length > 0,
    ),
  );
};
